<div class="bid-documents-dialog">
  <div class="dialog-header d-flex align-items-start justify-content-between">
    <div>
      <h2>Bid Documents</h2>
      <div class="subtitle">{{ data.bidId }}<span *ngIf="data.vendorName"> - {{ data.vendorName }}</span></div>
    </div>
    <button type="button" class="close-button" aria-label="Close" (click)="close()"><i class="fas fa-times"></i></button>
  </div>

  <div class="dialog-body">
    <div *ngIf="isLoading" class="empty-state"><i class="fas fa-spinner fa-spin me-2"></i>Loading documents...</div>
    <div *ngIf="!isLoading && documentGroups.length === 0" class="empty-state">No documents are available yet.</div>

    <section *ngFor="let group of documentGroups" class="document-group">
      <h3>{{ group.category }}</h3>
      <div *ngFor="let item of group.documents" class="document-row">
        <div class="document-name"><i class="fas fa-file-alt me-2"></i>{{ item.name || 'Document' }}</div>
        <div class="document-meta" *ngIf="formatFileSize(item.fileSize)">{{ formatFileSize(item.fileSize) }}</div>
        <div class="document-actions">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="viewDocument(item)" [disabled]="!item.fileContent">View</button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="downloadDocument(item)" [disabled]="!item.fileContent">Download</button>
        </div>
      </div>
    </section>
  </div>

  <div class="dialog-footer"><button type="button" class="btn btn-light" (click)="close()">Close</button></div>
</div>
